import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, TextField, Button, Alert } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import {forgot, resetPassword} from '../services/api';
import ForgotForm from "../components/ForgotForm";
import ResetPasswordForm from "../components/ResetPasswordForm";

const ResetPassword: React.FC = () => {
    const [loading, setLoading] = useState<boolean | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<boolean | null>(null);
    const validateEmail = (email: any) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleForgot = async (data: { email: string, otp: string, newPassword: string }) => {
        if (!validateEmail(data.email)){
            setError('Error email')
            return
        }
        try {
            setLoading(true)
            const response = await resetPassword(data.email, data.otp, data.newPassword);
            console.log('Restore successful:', response.data);
            setLoading(false)
            setSuccess(true)
            // navigate('/login'); // Перенаправление на страницу входа после успешной регистрации
        } catch (error: any) {
            setError(error.response.data.detail)
            setLoading(false)
            console.error('Login failed:', error.response.data.detail);
        }
    };

    return (
        <Box sx={{display: 'flex', height: '100vh'}}>
            <Container component="main" maxWidth="xs">
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: '100vh'
                }}>
                    <Box sx={{mt: 6}}>
                        <img src="/logo.svg" className='startLogo' alt=""/>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                        <ResetPasswordForm onSubmit={handleForgot} buttonText="Восстановить" loading={loading} error={error} success={success}/>
                    </Box>
                    <Box sx={{
                        mb: 4,
                        mt: 5,
                        display: 'block',
                        justifyContent: 'space-between',
                        width: '100%',
                        textAlign: 'center',
                        color: '#888'
                    }}>
                        2025
                    </Box>

                </Box>
            </Container>
        </Box>
    );
};

export default ResetPassword;
